module.exports = __webpack_public_path__ + "static/media/limousine.8b75d1b7.svg";